<template>
  <div class="register-container">
    <div class="register-form"> 
      <img class="icon" src="@/assets/icon/kayit-icon.svg" :alt="$t('auth.register.icon_alt')" />
      <h2>{{ $t('auth.register.title') }}</h2>
      <form @submit.prevent="handleRegister">
        <div class="form-group">
          <label for="email">{{ $t('auth.register.email') }}</label>
          <input type="email" id="email" v-model="e_mail" required />
        </div>
        <div class="form-group">
          <label for="username">{{ $t('auth.register.username') }}</label>
          <input type="text" id="username" v-model="user_name" required />
        </div>
        <div class="form-group">
          <label for="firstName">{{ $t('auth.register.first_name') }}</label>
          <input type="text" id="firstName" v-model="first_name" required />
        </div>
        <div class="form-group">
          <label for="lastName">{{ $t('auth.register.last_name') }}</label>
          <input type="text" id="lastName" v-model="last_name" required />
        </div>
        <div class="form-group">
          <label for="phone">{{ $t('auth.register.phone') }}</label>
          <input type="tel" id="phone" v-model="phone_number" required />
        </div>
        <div class="form-group">
          <label for="password">{{ $t('auth.register.password') }}</label>
          <input type="password" id="password" v-model="password" required />
        </div>
        <div class="form-group">
          <label for="confirmPassword">{{ $t('auth.register.confirm_password') }}</label>
          <input type="password" id="confirmPassword" v-model="confirmPassword" required />
        </div>
        <button type="submit">{{ $t('auth.register.submit') }}</button>
      </form>
      <div class="register-links">
        <p>
          {{ $t('auth.register.already_member') }}
          <span @click="navigateToLogin" class="link" style="font-weight: 800;">{{ $t('auth.register.go_login') }}</span>
        </p>
      </div>
      <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      e_mail: '',
      user_name: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      password: '',
      confirmPassword: '',
      successMessage: ''
    };
  },
  methods: {
    async handleRegister() {
      if (this.password !== this.confirmPassword) {
        alert(this.$t('auth.register.password_mismatch'));
        return;
      }

      try {
        const response = await axios.post('/auth/customer/register', {
          e_mail: this.e_mail,
          user_name: this.user_name,
          first_name: this.first_name,
          last_name: this.last_name,
          phone_number: this.phone_number,
          password: this.password
        });

        if (response.status === 201) {
          this.successMessage = this.$t('auth.register.success');
          setTimeout(() => {
            this.$router.push({ path: '/login' });
          }, 4000);
        } else {
          alert(response.data.message || this.$t('auth.register.failed'));
        }
      } catch (error) {
        console.error('Kayıt yapılırken hata oluştu:', error);
        const msg = error.response?.data?.message || this.$t('errors.generic_try_again');
        alert(msg);
      }
    },
    navigateToLogin() {
      this.$router.push({ path: '/login' });
    }
  }
};
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh; 
  text-align: left;
  padding: 120px 0;
}

.register-form { 
  padding: 2em;
  background: #050505;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px; 
}

h2 {
  margin-bottom: 1em; 
  color: #065959;
}
.icon {
  max-width: 8em;
}
.form-group {
  margin-bottom: 1.5em;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 0.5em; 
} 

button {
  width: 100%;
  padding: 0.75em;
  border: none;
  border-radius: 5px;
  background-color: #065959;
  color: white;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #187774;
}

.register-links {
  margin-top: 2em; 
  color: #555;
}

.link {
  color: #065959;
  cursor: pointer;
  text-decoration: none;
}

.link:hover {
  color: #187774;
}

.success-message {
  margin-top: 1em;
  color: #4caf50;
  font-weight: bold;
  text-align: center;
}
</style>
